import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { TEAMS_READERS } from '../auth/roles.ts'
import { guardRoute } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'

export const teamDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/teams/$teamId',
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: TEAMS_READERS,
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/team-detail.tsx')),
})

/** The link to one squad, so a caller never restates the path. */
export function teamDetailLink(teamId: number) {
  return { to: '/teams/$teamId', params: { teamId: String(teamId) } } as const
}
